import React, { useEffect, useState } from 'react'
import ActivityTab from './Tabs/ActivityTab';
import NotesTab from './Tabs/NotesTab';
import ProfileTab from './Tabs/ProfileTab';
import TaskTab from './Tabs/TaskTab';
export default function DetailsBody({ TABS, TASKS_TABS, currentTab, tabChanged, personData, refetchPerson }) {

  // useEffect(() => {
  //   
  // }, [currentTab])

  //Tab Component
  const NavTab = (tab) => {
    let currentStatus = '';
    if (currentTab.id === tab.tabinfo.id) {
      currentStatus = 'active';
    } else {
      currentStatus = '';
    }

    return (
      <li className='nav-item'>
        <a
          onClick={() => {
            tabChanged(tab.tabinfo);
          }}
          className={`nav-link ${currentStatus}`}
          href={'#' + tab.tabinfo.id}
          role='tab'
          data-toggle='tab'
          key={tab.key_id}
        >
          <i className={tab.tabinfo.icon}></i> {tab.tabinfo.name}
        </a>
      </li>
    );
  };


  return (
    <div className='mt-4'>
      <div className='cmpgn_list_outer'>
        <div className='cmpgn_tab_erap'>
          <ul className='nav nav-tabs' role='tablist' >
            {
              TABS.map(tab => {
                return <NavTab tabinfo={tab} key={tab.id} />
              })
            }
          </ul>
          <div className='tab-content' style={{ padding: 0 }}>
            <div role='tabpanel' className='tab-pane active' id='ACTIVITY_TAB'>
              {
                currentTab.id === 'ACTIVITY_TAB' ? <ActivityTab personData={personData} /> : ''
              }
            </div>
            <div role='tabpanel' className='tab-pane ' id='PROFILE_TAB'>
              {
                currentTab.id === 'PROFILE_TAB' ? <ProfileTab personData={personData} refetchPerson={refetchPerson} /> : ''
              }
            </div>
            <div role='tabpanel' className='tab-pane ' id='TASKS_TAB'>
              {
                currentTab.id === 'TASKS_TAB' ? <TaskTab personData={personData} userFlow={'personFlow'} /> : ''
              }
            </div>
            <div role='tabpanel' className='tab-pane ' id='NOTES_TAB'>
              {
                currentTab.id === 'NOTES_TAB' ? <NotesTab personData={personData} /> : ''
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
